import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

const PREFS = [
  ["daily_schedule", "Morning schedule", "Every day at 7:00: the times you're on air, with your story card."],
  ["on_air", "On Air Now alert", "A few minutes before your track airs."],
  ["weekly_report", "Monday weekly report", "Plays, listeners, Flames and chart positions of last week."],
];

export const EmailPrefs = ({ prefs }) => {
  const [p, setP] = useState(prefs);
  const toggle = async (k, v) => {
    const next = { ...p, [k]: v };
    setP(next);
    try { await api.put("/me/email-prefs", next); toast.success("Email settings saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="panel p-6" data-testid="email-prefs">
      <div className="label-mono mb-4 flex items-center gap-2"><Mail className="h-3.5 w-3.5" />Automatic emails</div>
      {PREFS.map(([k, t, s]) => (
        <label key={k} className="flex items-center justify-between gap-4 border-b border-white/5 py-3">
          <span><span className="block font-display font-bold">{t}</span><span className="text-sm text-slate-400">{s}</span></span>
          <Switch checked={p[k]} onCheckedChange={(v) => toggle(k, v)} data-testid={`email-pref-${k}`} />
        </label>
      ))}
      <p className="mt-3 text-xs text-slate-500">Welcome, review results, receipts and prizes are always sent.</p>
    </div>
  );
};
